<template>
  <div class="report-view" :class="{ 'pdf-report-loading': printingReport }">
      <div class="dash-header">
        <h1>
          <i class="far fa-history"></i>
          Reporte de conexión
          <span v-html="filtersRequiredSet ? filtersHead : 'Seleccione los filtros para los datos del reporte'"></span>
          <b-button class="update-btn" size="sm" variant="outline-primary" @click="refreshData" v-if="!loadingData && (!usersData || usersData.length > 0) && !printingReport">Actualizar</b-button>
        </h1>
      </div>

      <div v-if="filtersRequiredSet">
        <div v-show="!loadingData && usersData && usersData.length > 0">
          <div class="kpis-params">
            <div class="hour-slider">
              <round-slider
                v-model="sliderValue"
                editableTooltip="false"
                sliderType="range"
                line-cap="round"
                min="0"
                max="23"
                radius="62"
                width="15"
                startAngle="90"
                rangeColor="#3498db"
                :change="onHourSliderChange"/>

                <p>Rango de horas</p>
                <a href="#" @click="resetTimeRange" v-if="initHour !== 0 || endHour !== 23">Restablecer</a>
            </div>

            <div class="kpis items">
              <div class="indicator-item static-color" v-for="(item, index) in kpis" :key="item.name" :class="[item.color]" :style="{ 'animation-delay': index * 50 + 'ms' }">
                <i class="fal" :class="[item.icon]"></i>
                <h1>{{ item.value | formatNum }} {{ item.suffix }}</h1>
                <label v-html="item.name"/>
              </div>

              <div class="indicator-item static-color" :class="['aqua']" :style="{ 'animation-delay': 2 * 50 + 'ms' }" v-if="groupsAverageUsersConnnected.length > 0">
                <i class="fal fa-medal"></i>
                <div class="group-average-connection-list">
                  <div v-for="(item, index) in groupsAverageUsersConnnected" :key="index" v-show="index < 3" class="text-truncate" :title="`${index + 1}) ${item.group} (${item.average}%)`">
                    {{ index + 1 }}) {{ item.group }} ({{ item.average }}%)
                  </div>
                </div>
                <label>Grupo con mayor porcentaje de usuarios conectados</label>
              </div>

              <div class="indicator-item static-color" :class="['yellow']" :style="{ 'animation-delay': 3 * 50 + 'ms' }" v-if="hoursWithUsersConnnected.length > 0">
                <i class="fal fa-chart-line"></i>
                <div class="group-average-connection-list">
                  <div v-for="(item, index) in hoursWithUsersConnnected" :key="index" v-show="index < 3" class="text-truncate">
                    {{ index + 1 }}) {{ item.hour }} hrs. ({{ item.usersCount }} usuarios)
                  </div>
                </div>
                <label>Horas con más usuarios conectados</label>
              </div>
            </div>
          </div>

          <div class="kpis" v-if="!refreshingCharts && gridGroupsDetail.length <= 12">
            <h2>Gráfica comparativa de grupos</h2>
            <div class="kpi-item chart">
              <LineChart :chartdata="globalChartDataCollection" :options="{ responsive: true,  maintainAspectRatio: false, legend: { display: true, position: 'top', maxWidth: 150 }, tooltips: chartsTooltips, scales: chartsScales, plugins: chartsPlugins }" style="position: relative; height:350px; width:100%"/>
            </div>
          </div>

          <br>

          <div class="kpis grid-indicators" v-if="chartsDataCollection.length">
            <h2>Tabla comparativa de usuarios conectados por grupo, en el lapso de: {{ initHour }}:00 a {{ endHour }}:59 hrs.</h2>

            <table class="table table-hover detail scrolled" :class="{ 'tconn-g': gridGroupsDetail.length > 1 }">
              <thead class="table-header">
                <tr>
                  <th :colspan="endHour - initHour + 2" style="width: 100%">
                    <div class="table-filters-groups-detail">
                      <b-form-checkbox
                        v-model="gridGroupDetailShowBars"
                        switch>
                        Mostrar barras
                      </b-form-checkbox>

                      <b-form-checkbox
                        v-model="gridGroupDetailShowValue"
                        switch>
                        Mostrar porcentaje
                      </b-form-checkbox>
                    </div>
                  </th>
                </tr>
                <tr style="border-top: 1px solid #ffffff26;">
                  <th scope="col" style="width: 170px;">Grupo</th>
                  <td scope="col" class="col-hour-number" v-for="index in (endHour - initHour + 1)" :key="index">{{ initHour + (index-1) }}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in gridGroupsDetail" :key="index" v-show="/*item.user.includes(searchUsers)*/true">
                  <th class="group-name" style="width: 170px;">{{ item.groupName }}</th>
                  <td scope="col" class="col-check check"
                    v-for="index in (endHour - initHour + 1)" :key="index"
                    :title="item[initHour + (index-1)].numberUsersAtTime + ' de ' + item.totalUsers + ' Usuarios conectados'">
                    <div class="check-bar percent"
                      :class="[getGroupHourColor(item[initHour + (index-1)].averageConnectedUsers)]"
                      :style="{ width: 'calc(' + item[initHour + (index-1)].averageConnectedUsers + '% - 2px) !important' }"
                      v-show="gridGroupDetailShowBars">
                    </div>
                    <div class="percent-value" v-show="gridGroupDetailShowValue">{{ item[initHour + (index-1)].averageConnectedUsers || 0 }}%</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="kpis grid-indicators page-break" v-if="gridUsersDetail.length > 0">
            <h2>Detalle de usuarios conectados en el lapso de: {{ initHour }}:00 a {{ endHour }}:59 hrs.</h2>

            <table class="table table-hover detail scrolled tconn-u">
              <thead class="table-header">
                <tr v-if="!printingReport && gridUsersDetail && gridUsersDetail.length >= 20">
                  <th colspan="2">
                    <div class="table-filters">
                      <b-form-input v-model="searchUsers" placeholder="Buscar usuarios"></b-form-input>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th scope="col" class="sortable" style="width: 170px;">Usuario</th>
                  <td scope="col" class="col-hour-number" v-for="index in (endHour - initHour + 1)" :key="index">{{ initHour + (index-1) }}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in gridUsersDetail" :key="index" v-show="item.user.includes(searchUsers)">
                  <th class="user-name" style="width: 170px;">
                    {{ item.user }}
                    <label class="text-truncate">{{ item.group }}</label>
                  </th>
                  <td scope="col" class="col-check" v-for="index in (endHour - initHour + 1)" :key="index"
                    :class="{ check: item[initHour + (index-1)].status, 'round-left': !item[initHour + (index-2)] || item[initHour + (index-2)].status === 0, 'round-right': !item[initHour + (index)] || item[initHour + (index)].status === 0 }">
                    <div class="check-bar"><span>{{ index - 1 }}</span></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!--section class="charts" v-if="!refreshingCharts">
            <div class="page-brak"></div>
            <div class="kpis" v-for="(item, index) in chartsDataCollection" :key="index" :class="{ 'page-break': index % 5 === 0 }">
              <h2>{{ item.name }}</h2>
              <div class="kpi-item chart">
                <LineChart :chartdata="item" :options="{ responsive: true,  maintainAspectRatio: false, legend: { display: true }, tooltips: chartsTooltips, scales: chartsScales, plugins: chartsPlugins }" style="position: relative; height:220px; width:100%"/>
              </div>
            </div>
          </section-->
        </div>

        <h3 class="no-data-message" v-if="!loadingData && (!usersData || usersData.length === 0)">No se encontraron datos para los filtros seleccionados</h3>

        <div v-if="loadingData" class="mock-loading">
          <div class="kpis items">
            <div class="indicator-item animate__animated animate__shakeX" v-for="index in 5" :key="index"></div>
          </div>

          <div class="kpis">
            <div class="kpi-item chart animate__animated animate__shakeX"></div>
          </div>
        </div>

      </div>

      <div v-else class="default-image">
        <video playsinline="" autoplay="" muted="" loop="" width="100%">
          <source src="@/assets/img/reports/report-connection.mp4" type="video/mp4">
        </video>
      </div>

      <a class="hidden-csv-download-link" ref="csvDownload"></a>
      <a class="hidden-csv-download-link" ref="csvDownload2"></a>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import moment from 'moment'
import { AbstractReportComponent } from './AbstractReportComponent'
import TableKpiCompareItem from '@/components/dashboard/TableKpiCompareItem.vue'
import { KpiItem, FiltersDateFormats, KpisStatusManagement, KpisConnectionReportData, KpisGroupIndicatorsByTime, KpisGroupIndicatorsBySpecificTime, KpisConnectionReportDataUsers, KpisConnectionReportDataUserIndicator } from '@/types/Dashboard'
import LineChart from '@/components/charts/LineChart.vue'
import reportsService from '@/services/ReportsService'
import RoundSlider from 'vue-round-slider'

const COLORS = [
  '#37bc9b', '#f6bb42', '#3bafda', '#967adc', '#d770ad', '#4a89dc', '#999999',
  '#1c7c66', '#a78034', '#285d70', '#6442b9', '#bd3185', '#3d4753', '#383838',
  '#0c4739', '#926813', '#16313b', '#4f4174', '#c779a8', '#6a7c92', '#855858',
  '#008163', '#857149', '#0080af', '#5b536e', '#806374', '#323f50', '#491b1b',
  '#24a587', '#33312c', '#5895ac', '#2f2644', '#503a47', '#1c3657', '#292525',
  '#19641c', '#6c7c46', '#1f4b8f', '#7a5991', '#3f203d', '#272b61', '#724343',
  '#37bc9b', '#f6bb42', '#3bafda', '#967adc', '#d770ad', '#4a89dc', '#999999',
  '#1c7c66', '#a78034', '#285d70', '#6442b9', '#bd3185', '#3d4753', '#383838',
  '#0c4739', '#926813', '#16313b', '#4f4174', '#c779a8', '#6a7c92', '#855858',
  '#008163', '#857149', '#0080af', '#5b536e', '#806374', '#323f50', '#491b1b',
  '#24a587', '#33312c', '#5895ac', '#2f2644', '#503a47', '#1c3657', '#292525',
  '#19641c', '#6c7c46', '#1f4b8f', '#7a5991', '#3f203d', '#272b61', '#724343',
  '#37bc9b', '#f6bb42', '#3bafda', '#967adc', '#d770ad', '#4a89dc', '#999999',
  '#1c7c66', '#a78034', '#285d70', '#6442b9', '#bd3185', '#3d4753', '#383838',
  '#0c4739', '#926813', '#16313b', '#4f4174', '#c779a8', '#6a7c92', '#855858',
  '#008163', '#857149', '#0080af', '#5b536e', '#806374', '#323f50', '#491b1b',
  '#24a587', '#33312c', '#5895ac', '#2f2644', '#503a47', '#1c3657', '#292525',
  '#19641c', '#6c7c46', '#1f4b8f', '#7a5991', '#3f203d', '#272b61', '#724343',
  '#37bc9b', '#f6bb42', '#3bafda', '#967adc', '#d770ad', '#4a89dc', '#999999',
  '#1c7c66', '#a78034', '#285d70', '#6442b9', '#bd3185', '#3d4753', '#383838'
]

@Component({
  components: {
    TableKpiCompareItem,
    LineChart,
    RoundSlider
  },
  filters: {
    formatNum (value: number) {
      return value.toLocaleString('en')
    }
  }
})
export default class ReportConexion extends AbstractReportComponent {
  usersData: KpisConnectionReportData[] = []
  mainKpis = new KpisStatusManagement()
  groupsAverageUsersConnnected: any[] = []
  hoursWithUsersConnnected: any[] = []

  initHour = 0
  endHour = 23

  sliderValue = '0,23'

  // Main KPIs
  kpis: KpiItem[] = []

  searchUsers = ''

  tableUsernameSortDirAsc = true
  tableAmountSortDirAsc = false
  gridGroupDetailShowBars = true
  gridGroupDetailShowValue = true

  // Charts
  chartsDataCollection: any[] = []
  globalChartDataCollection: any = {}
  chartDataGlobal: any = {}
  gridUsersDetail: KpisConnectionReportDataUsers[] = []
  gridGroupsDetail: KpisGroupIndicatorsByTime[] = []
  groupSelectedData: KpisConnectionReportData
  refreshingCharts = false

  options = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          let valueNum = Number(data.datasets[0].data[tooltipItem.index] || 0)
          return valueNum.toLocaleString('en')
        }
      }
    }
  }

  chartsTooltips = {
    callbacks: {
      label: (tooltipItem: any) => {
        let valueNum = Number(tooltipItem.yLabel || 0)
        return valueNum.toLocaleString('en') + '%'
      },
      title: (tooltipItem: any) => {
        return tooltipItem[0].label + ' hrs.'
      }
    }
  }

  chartsScales = {
    yAxes: [{
      ticks: {
        beginAtZero: true,
        callback: (value: any) => {
          let valueNum = Number(value || 0)
          return valueNum.toLocaleString('en') + '%'
        }
      }
    }]
  }

  chartsPlugins = {
    datalabels: {
      display: false
    }
  }

  created () {
    this.$store.commit('global/updateFiltersReportConexion')
  }

  mounted () {
    this.initialPageTitle = document.title
    this.filter(this.$route.query as any)
    this.$root.$on('export-report', this.exportReport)
    window.addEventListener('afterprint', this.afterPrintPdfReport)
  }

  beforeDestroy () {
    document.title = this.initialPageTitle
    this.$root.$off('export-report', this.exportReport)
    window.removeEventListener('afterprint', this.afterPrintPdfReport)
  }

  get filtersRequiredSet () {
    return !!this.filters.group
  }

  get userGroupsDictionary () {
    return this.$store.state.global.userGroupsDictionary
  }

  async refreshData () {
    if (!this.filtersRequiredSet) return

    this.loadingData = true
    this.usersData = []
    this.$store.commit('global/lockReportFilters', true)

    this.tableUsernameSortDirAsc = true
    this.tableAmountSortDirAsc = false

    try {
      // 1. Get data
      let usersData: KpisConnectionReportData[] = []
      await reportsService.getReporteConexion(this.filters)
        .then((response) => { usersData = response })
        .catch((error) => {
          this.$bvToast.toast(
            `Error al consultar la información para el reporte: ${error.response.data.message}.
            Por favor, intenta con otros valores de consulta.
            `,
            { title: 'Error en la consulta', variant: 'danger', autoHideDelay: 6000 })
          this.endPrint()
          this.$store.commit('global/lockReportFilters', false)
        })

      // 2. Set group name and sort by it
      usersData.forEach((it) => {
        it.groupName = this.userGroupsDictionary[it.groupId]
        it.users = it.users.sort((a, b) => (a.user.toLowerCase() > b.user.toLowerCase()) ? 1 : -1)
        it.users.forEach(usr => {
          usr.group = it.groupName
        })
      })
      usersData.sort((a, b) => (a.groupName.toLowerCase() > b.groupName.toLowerCase()) ? 1 : -1)

      // Copy all users from subgroup into the selected group
      this.groupSelectedData = (usersData.find(it => it.groupId === this.filters.group.toString()) || { users: [] as KpisConnectionReportDataUsers[] }) as KpisConnectionReportData
      usersData = usersData.filter(it => it.groupId !== this.filters.group.toString())
      usersData.forEach((it) => {
        this.groupSelectedData.users = this.groupSelectedData.users.concat(it.users)
        this.groupSelectedData.totalUsers += it.totalUsers
      })

      // Add selected group at the begining
      usersData.unshift(this.groupSelectedData as KpisConnectionReportData)

      this.usersData = usersData

      this.gridUsersDetail = this.groupSelectedData.users

      this.gridGroupsDetail = this.usersData.map(it => {
        return reportsService.getGroupIndicatorsByTimeKpis(it)
      })

      this.refreshMainKpis()
      this.refreshChartsKpis()
    } finally {
      setTimeout(() => {
        this.loadingData = false
        this.$store.commit('global/lockReportFilters', false)
      }, 500)
    }
  }

  refreshFiltersInfo () {
    let result = []
    if (this.filtersStore.group) {
      result.push('Grupo: ' + this.filtersStore.groupName)
    }

    const date = 'Del ' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('D [de] MMMM [de] YYYY')
    result.push(date)

    result.push(`de las ${this.initHour}:00 hrs. a las ${this.endHour}:59 hrs.`)

    this.filtersHead = result.join(', ')
  }

  refreshMainKpis () {
    this.kpis = []
    let currentItem: KpisGroupIndicatorsBySpecificTime

    let totalUsersConnectedByHour = [...Array(24).keys()].map(i => 0)
    let maxUsersConnected = 0

    const mainGroupDetail = this.gridGroupsDetail[0]
    const subGroups = this.gridGroupsDetail.filter((it, index) => index > 0)

    let averageConnection = 0
    for (let i = this.initHour; i <= this.endHour; i++) {
      currentItem = mainGroupDetail[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime
      totalUsersConnectedByHour[i] += currentItem.numberUsersAtTime
      averageConnection += currentItem.averageConnectedUsers
    }
    averageConnection = averageConnection / (this.endHour - this.initHour + 1)

    let groupsAverageUsersConnnected: any[] = []
    subGroups.forEach(it => {
      let averageConnection = 0
      for (let i = this.initHour; i <= this.endHour; i++) {
        currentItem = it[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime
        averageConnection += currentItem.averageConnectedUsers
      }
      averageConnection = averageConnection / (this.endHour - this.initHour + 1)
      groupsAverageUsersConnnected.push({ group: it.groupName, average: +averageConnection.toFixed(1) })
    })

    // Max users connected in an hour
    maxUsersConnected = Math.max.apply(null, totalUsersConnectedByHour)

    // Hour with the most users connected
    this.hoursWithUsersConnnected = totalUsersConnectedByHour.map((it, index) => { return { hour: index, usersCount: it } }).filter(it => it.usersCount > 0).sort((a, b) => (a.usersCount < b.usersCount) ? 1 : -1)

    // Group with the most users connected
    this.groupsAverageUsersConnnected = groupsAverageUsersConnnected.filter(it => it.average > 0).sort((a, b) => (a.average < b.average) ? 1 : -1)

    // Adding Kpis results to the list ********************************************
    this.kpis.push(
      KpiItem.getInstance().withName('Promedio general de<br>usuarios conectados').withValue(+averageConnection.toFixed(1)).withSuffix('%').withIcon('fa-user-check').withColor('green')
    )
    this.kpis.push(
      KpiItem.getInstance().withName('Máximo de usuarios<br>conectados en una hora').withValue(maxUsersConnected).withIcon('fa-clock').withColor('purple')
    )
  }

  refreshGroupsWithMostUsersConnectedKpi () {

  }

  refreshChartsKpis () {
    this.refreshingCharts = true

    this.chartsDataCollection = this.gridGroupsDetail.map((it, index) => {
      let labels = []
      let values = []
      for (let i = this.initHour; i <= this.endHour; i++) {
        labels.push(i)
        values.push((it[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime).averageConnectedUsers)
      }
      return {
        name: it.groupName,
        totalUsers: 5,
        labels: labels,
        datasets: [
          {
            label: 'Usuarios activos',
            lineTension: 0.4,
            borderColor: COLORS[index],
            backgroundColor: COLORS[index] + '99',
            fill: true,
            data: values
          }
        ]
      }
    })

    this.globalChartDataCollection = {
      labels: this.chartsDataCollection[0].labels,
      datasets: this.chartsDataCollection.map((it, index) => {
        return {
          label: it.name,
          lineTension: 0.4,
          borderColor: it.datasets[0].borderColor,
          fill: false,
          data: it.datasets[0].data
        }
      })
    }

    setTimeout(() => {
      this.refreshingCharts = false
    }, 500)
  }

  getGroupHourColor (percentValue: number) {
    if (percentValue >= 0 && percentValue < 40) {
      return 'red'
    }

    if (percentValue >= 40 && percentValue < 70) {
      return 'yellow'
    }

    if (percentValue >= 70 && percentValue < 90) {
      return 'green-light'
    }

    if (percentValue >= 90) {
      return 'green-strong'
    }
  }

  onHourSliderChange (event: any) {
    const values = event.value.split(',')
    this.initHour = +values[0]
    this.endHour = +values[1]
    this.refreshMainKpis()
    this.refreshChartsKpis()
    this.refreshFiltersInfo()
  }

  resetTimeRange () {
    this.sliderValue = '0,23'
    this.initHour = 0
    this.endHour = 23
    this.refreshMainKpis()
    this.refreshChartsKpis()
    this.refreshFiltersInfo()
  }

  sortSourceDataByGroupName () {
    this.usersData.sort((a, b) => (a.groupName > b.groupName) ? 1 : -1)
  }

  exportReport (reportType: string) {
    switch (reportType) {
      case 'pdf':
        this.generatePdfReport()
        break
      case 'csv':
        this.generateCsvReport()
        break
    }
  }

  generatePdfReport () {
    this.validateRatio()
    this.searchUsers = ''
    this.startPrint()
    setTimeout(() => {
      window.print()
    }, 1200)
  }

  generateCsvReport () {
    const periodTitle = moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('DDMMYYYY')

    if (this.gridUsersDetail.length) {
      // HEADER
      let csv = 'GRUPO,USUARIO,'
      for (let i = this.initHour; i <= this.endHour; i++) {
        csv += i + ' hrs.,'
      }
      csv += '\n'

      // ROWS
      for (let it of this.gridUsersDetail) {
        csv += `${it.group},${it.user},`
        for (let i = this.initHour; i <= this.endHour; i++) {
          csv += ((it[i as keyof KpisConnectionReportDataUsers] as KpisConnectionReportDataUserIndicator).status ? 'X' : '') + ','
        }
        csv += '\n'
      }

      let element = this.$refs.csvDownload as any
      element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      element.target = '_blank'
      element.download = `${periodTitle}_${this.filtersStore.groupName}_RptConexionUsuarios.csv`
      element.click()
    }

    if (this.gridGroupsDetail.length) {
      // HEADER
      let csv = 'GRUPO,'
      for (let i = this.initHour; i <= this.endHour; i++) {
        csv += i + ' hrs.,'
      }
      csv += '\n'

      // ROWS
      for (let it of this.gridGroupsDetail) {
        csv += `${it.groupName},`
        for (let i = this.initHour; i <= this.endHour; i++) {
          csv += `${(it[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime).numberUsersAtTime} (${(it[i as keyof KpisGroupIndicatorsByTime] as KpisGroupIndicatorsBySpecificTime).averageConnectedUsers}%),`
        }
        csv += '\n'
      }

      let element = this.$refs.csvDownload2 as any
      element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      element.target = '_blank'
      element.download = `${periodTitle}_${this.filtersStore.groupName}_RptConexionGrupos.csv`
      element.click()
    }
  }

  afterPrintPdfReport () {
    this.endPrint()
    document.title = this.initialPageTitle
  }
}
</script>

<style lang="scss" scoped>
.dash-header .update-btn {
  margin-top: 15px;
}

.default-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100% - 120px);
  overflow: visible;
  z-index: 0;
  video {
    width: 50%;
    min-width: 400px;
    opacity: 0.25;
  }
}

.table-filters {
  width: 350px;
  margin: 10px 0;
}

.table-filters-groups-detail {
  display: flex;
  .custom-switch  {
    margin-right: 25px;
  }
}

.grid-indicators {
  .col-hour-number {
    padding: 0 !important;
    font-size: .75rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 350ms;
    width: 0;
  }
  .col-check {
    padding: 0 !important;
    font-size: .75rem !important;
    display: flex;
    align-items: center;
    position: relative;
    transition: all 350ms;
    width: 0;
    &:hover {
      box-shadow: inset 0 0 2px 1px #555;
    }
    .check-bar {
      display: none;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: #fff;
        font-weight: bold;
        opacity: 0;
        transition: opacity 250ms ease;
      }
    }
    &.check .check-bar {
      position: absolute;
      z-index: 1;
      display: block;
      width: calc(100% + 1px);
      height: 50%;
      max-height: 20px;
      background-color: #37aa8d;
      &.percent {
        left: 2px;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
        &.red {
          background-color: rgb(216, 109, 109);
        }
        &.yellow {
          background-color: rgb(199, 181, 19);
        }
        &.green-light {
          background-color: #8cc7b8;
        }
        &.green-strong {
          background-color: #37aa8d;
        }
      }
    }
    &.check.round-left .check-bar {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    &.check.round-right .check-bar {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .percent-value {
      $text-shadow-color: #fff;
      position: absolute;
      z-index: 2;
      font-size: .57rem;
      top: 50%;
      left: 5px;
      font-weight: bold;
      color: #5a5a5a;
      transform: translateY(-50%);
      text-shadow: $text-shadow-color 1px 1px 1px, $text-shadow-color -1px -1px 1px, $text-shadow-color 1px -1px 1px, $text-shadow-color -1px 1px 1px, $text-shadow-color 1px 1px 1px, $text-shadow-color -1px -1px 1px, $text-shadow-color 1px -1px 1px, $text-shadow-color -1px 1px 1px;
    }
  }
  th.group-name {
    font-size: 0.7rem !important;
  }
  th.user-name {
    position: relative;
    label {
      position: absolute;
      top: 24px;
      font-size: 0.6rem;
      font-weight: 400;
      color: #6d6d6d;
      left: 12px;
      right: 12px;
      overflow: hidden !important;
    }
  }

  tr:hover {
    .check .check-bar span{
      opacity: 0.5;
    }
  }
  tr:first-child {
    padding-top: 0 !important;
  }
  tbody tr td:last-child {
    .check-bar {
      width: 90% !important;
    }
  }
  thead tr td {
    border-left: 1px solid #ffffff26 !important;
  }
  tbody tr td {
    border-left: 1px solid #d4d4d499 !important;
  }
  thead, tbody {
    // overflow: hidden !important;
    direction: ltr;
  }
}

.pdf-report-loading .pie-charts {
  display: block;
  *[class^='col-'] {
    max-width: 100%;
  }

  .kpi-item.chart > div {
    height: 450px !important;
    background-color: #f8f8f8;
    padding: 20px;
    border-radius: 7px;
  }
}

.no-data-message {
  text-align: center;
  max-width: 450px;
  margin: 0 auto;
  padding-top: 5%;
  color: #acacac;
}

.kpis-params {
  padding: 7px 28px;
  display: flex;
  .hour-slider {
    box-shadow: 2px 2px 7px -2px #a7a7a7;
    padding: 15px;
    margin: 8px 15px 8px 0;
    p {
      margin: 7px 0 0 5px;
      font-weight: bold;
      color: #555;
    }
    a {
      margin: 0 0 0 5px;
      font-size: 0.75rem;
      color: #a3a3a3 !important;
    }
  }
  .kpis.items {
    flex: 1;
    padding: 0 !important;
    margin: 0;
    h1 {
      font-size: 3.5rem !important;
    }
    .group-average-connection-list {
      margin: 7px 0 5px 0;
      max-height: 75px;
      font-size: 0.8rem;
      div {
        overflow: hidden;
      }
    }
  }
}
</style>
